import React from "react";
import { Compass, ExternalLink, ArrowRight } from "lucide-react";

const links = [
  { label: "About", href: "/about" },
  { label: "Pay Invoice", href: "/invoice-payment" },
  { label: "Testimonials", href: "/home#testimonials" },
  { label: "Non-Profits", href: "/non-profits" },
  { label: "Portfolio", href: "/portfolio" },
  { label: "Tools", href: "https://tools.host1help1.com/", external: true },
  { label: "Send Me Info", href: "https://secrets.host1help1.com", external: true },
  { label: "QR Codes", href: "https://my-qr.base44.app", external: true },
];

export default function WhatElseCard({ index = 0 }) {
  return (
    <div
      className="bg-card border border-border rounded-none shadow-sm hover:shadow-md hover:border-[#F18D50] transition-all flex flex-col p-6"
    >
      <div className="w-11 h-11 flex items-center justify-center bg-primary/[0.08] mb-4">
        <Compass className="w-6 h-6 text-[#F18D50]" />
      </div>
      <h3 className="text-lg font-bold mb-3 leading-snug">What else?</h3>
      <ul className="space-y-1.5">
        {links.map((link) => (
          <li key={link.label}>
            <a
              href={link.href}
              target={link.external ? "_blank" : undefined}
              rel={link.external ? "noopener noreferrer" : undefined}
              className="inline-flex items-center gap-1.5 text-sm font-medium text-muted-foreground hover:text-[#F18D50] transition-colors"
            >
              <ArrowRight className="w-3.5 h-3.5 text-[#F18D50]" />
              {link.label}
              {link.external && <ExternalLink className="w-3 h-3" />}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}